<script setup>
import {ref, watch} from "vue";
import PaymentModal from "@/components/ecosystem/PaymentModal.vue";
import {useStore} from "vue2-helpers/vuex";

const store = useStore();

const showModal = ref(false);
const paymentModal = ref(null);

watch(() => store.state.showUpsell, value => {
    if (value && store.getters.isEcosystem) {
        open();
    }
})

function showPaymentModal() {
    showModal.value = false;
    paymentModal.value.open();
}

function paymentClosed() {
    if (!store.getters.isPremiumEcosystem) {
        showModal.value = true;
    }
}

function open() {
    showModal.value = true;
}

defineExpose({
    open
});
</script>

<template>
    <div>
        <Modal v-model="showModal" hide-footer hide-header modal-class="modal-upsell">
            <div class="modal-content__inner modal-content__inner--dark">
                <header class="modal-header">
                    <button @click="showModal = false" class="close"></button>
                </header>

                <h5 class="modal-title">Unlock Portfolio-Wide Matching</h5>
                <p>Upgrade to recommend any startup and unlock:</p>
                <ul class="list-upsell">
                    <li>No limits on recommendation submissions</li>
                    <li>Submit any startup in your portfolio</li>
                    <li>View recommendation status</li>
                    <li>Unlimited users</li>
                </ul>
                <button class="modal-upsell__button" @click="showPaymentModal()">Activate Full Access</button>

                <footer class="modal-footer">
                    <a href="https://meetings.hubspot.com/marigona-xhemaili" target="_blank" class="link">Schedule A Demo Call</a>
                </footer>

            </div>
        </Modal>

        <PaymentModal
            ref="paymentModal"
            @closed="paymentClosed"
        />
    </div>
</template>

<style scoped>
</style>
